import { Fragment, useEffect, useState } from "react";

import {
	Button,
	Col,
	DatePicker,
	Form,
	Input,
	Row,
	Select,
	TimePicker,
	Typography,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addManualAttendance, loadAllAttendance, loadAllAttendancePaginated } from "../../redux/rtk/features/attendance/attendanceSlice";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import dayjs from 'dayjs';
const Attendance = ({ drawer }) => {
	const [loader, setLoader] = useState(false);
	const users = useSelector((state) => state.users?.list);
	const today = dayjs();
	  const [selectedYear, setSelectedYear] = useState(today.year());
	const [selectedMonth, setSelectedMonth] = useState(today.month() + 1);
	const dispatch = useDispatch();
	const { Title } = Typography;
	const [form] = Form.useForm();

	const [inTimeDate, setInTimeDate] = useState({
		time: null,
		date: null,
	});
	const [outTimeDate, setOutTimeDate] = useState({
		time: null,
		date: null,
	});

	const inTimeDateNew = inTimeDate.date && inTimeDate.time
		? new Date(Date.UTC(
			inTimeDate.date.split('-')[0], // Year
			inTimeDate.date.split('-')[1] - 1, // Month (0-indexed)
			inTimeDate.date.split('-')[2], // Day
			...inTimeDate.time.split(':').map(Number) // Hour, Minute, Second
		))
		: null;

	const outTimeDateNew = outTimeDate.date && outTimeDate.time
		? new Date(Date.UTC(
			outTimeDate.date.split('-')[0],
			outTimeDate.date.split('-')[1] - 1,
			outTimeDate.date.split('-')[2],
			...outTimeDate.time.split(':').map(Number)
		))
		: null;


	useEffect(() => {
		dispatch(loadAllStaff({ status: true }));
	}, []);

	const onFinish = async (values) => {
		const FormData = {
			...values,
			PunchInTime: inTimeDateNew instanceof Date && !isNaN(inTimeDateNew) ? inTimeDateNew : null,
			PunchOutTime: outTimeDateNew instanceof Date && !isNaN(outTimeDateNew) ? outTimeDateNew : null,
		};
		setLoader(true);
		const resp = await dispatch(addManualAttendance(FormData));
		if (resp.payload.message === "success") {
			setLoader(false);
			form.resetFields();
			  dispatch(loadAllAttendancePaginated({
				  Month: selectedMonth,
				  Year: selectedYear,
				}));
		} else {
			setLoader(false);
		}
	};
	const onFinishFailed = (errorInfo) => {
		toast.warning("Failed at adding shift");
		setLoader(false);
	};

	return (
		<Fragment>
			{/* <UserPrivateComponent permission={"create-attendance"}> */}
				<Row >
					<Col
						// xs={24}
						// sm={24}
						// md={24}
						// lg={drawer ? 22 : 12}
						// xl={drawer ? 22 : 12}
						// className='column-design border rounded card-custom'>
						>
						
						<Form
							form={form}
							eventKey='user-form'
							name='basic'
							
							onFinish={onFinish}
							onFinishFailed={onFinishFailed}
							autoComplete='off'>
							<div>
								<Form.Item
									style={{ marginBottom: "10px" }}
									label='User'
									name='EmployeeId'
									rules={[
										{
											required: true,
											message: "Please input your user!",
										},
									]}>
									<Select placeholder='Select User'
									showSearch allowClear
									filterOption={(input, option) =>
										String(option.children).toLowerCase().includes(input.toLowerCase())
									}>
										{users?.map((user) => (
											<Select.Option key={user.EmployeeId} value={user.EmployeeId}>
												{user.UserName}
											</Select.Option>
										))}
									</Select>
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									label='Start Time'>
									<div className='flex justify-between'>
										<DatePicker
											format={"YYYY-MM-DD"}
											onChange={(date, dateString) =>
												setInTimeDate({ ...inTimeDate, date: dateString })
											}
										/>
										<TimePicker
											className='ml-4'
											format={"HH:mm:s"}
											onChange={(time, timeString) =>
												setInTimeDate({ ...inTimeDate, time: timeString })
											}
										/>
									</div>
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									label='End Time'
									>
									<div className='flex justify-between'>
										<DatePicker
											format={"YYYY-MM-DD"}
											onChange={(date, dateString) =>
												setOutTimeDate({ ...outTimeDate, date: dateString })
											}
										/>
										<TimePicker
											className='ml-4'
											format={"HH:mm:s"}
											onChange={(time, timeString) =>
												setOutTimeDate({ ...outTimeDate, time: timeString })
											}
										/>
									</div>
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									>
									<Button
										onClick={() => setLoader(true)}
										type='primary'
										size='large'
										htmlType='submit'
										block
										loading={loader}>
										Add Attendance
									</Button>
								</Form.Item>
							</div>
						</Form>
					</Col>
				</Row>
			
		</Fragment>
	);
};

export default Attendance;
